import React from 'react';
import CharacterList from '../components/CharacterList/CharacterList';

const CharactersPage = () => {
  return (
    <div>
     
      <CharacterList />
    </div>
  );
};

export default CharactersPage;
